import { render } from "./LyricsWeDeclareWar.vue?vue&type=template&id=027b10da&scoped=true"
import script from "./LyricsWeDeclareWar.vue?vue&type=script&lang=js"
export * from "./LyricsWeDeclareWar.vue?vue&type=script&lang=js"

import "./LyricsWeDeclareWar.vue?vue&type=style&index=0&id=027b10da&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027b10da"]])

export default __exports__